import { CA, BUY_URL, X_URL } from "@/lib/constants";
import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

const XLogo = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Footer = () => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CA);
      setCopied(true);
      toast.success("CA copied.");
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      toast.error("couldn't copy");
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 px-4 sm:px-8 lg:px-12 pt-16 pb-10 border-t-[3px] border-black"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div
              className="font-bangers leading-[0.85] text-black"
              style={{ fontSize: "clamp(56px, 10vw, 140px)" }}
            >
              SAY IT.
              <br />
              <span style={{ color: "#0057FF", WebkitTextStroke: "3px #000" }}>
                DAT BIH GAH.
              </span>
            </div>
          </div>
          <div className="lg:col-span-5 flex flex-col gap-3">
            <button
              type="button"
              data-testid="footer-copy-ca"
              onClick={copy}
              className="sticker p-4 flex items-center justify-between gap-3 text-left"
            >
              <div className="flex flex-col">
                <span className="font-luckiest text-xs tracking-widest">CONTRACT</span>
                <span className="font-mono text-xs sm:text-sm break-all">{CA}</span>
              </div>
              {copied ? <Check size={20} /> : <Copy size={20} />}
            </button>
            <div className="grid grid-cols-2 gap-2">
              <a
                href={BUY_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-buy"
                className="btn-chunky text-xs sm:text-sm justify-center"
              >
                BUY
              </a>
              <a
                href={X_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-x"
                aria-label="X / Twitter"
                className="btn-chunky btn-black text-xs sm:text-sm justify-center"
              >
                <XLogo size={14} /> X
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t-2 border-black flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 font-luckiest text-xs sm:text-sm">
          <span>© $DATBIHGAH · ON SOLANA</span>
          <span>
            NOT FINANCIAL ADVICE · MEME COIN · DYOR
          </span>
        </div>
      </div>
    </footer>
  );
};
